import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';

interface ServiceHomePart1eProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    onOpenModal?: (type: 'basic' | 'premium') => void;
    onOpenNote?: (type: 'basic' | 'premium') => void;
}

interface eInteriorData {
    number: string;
    infoString: string;
}

const ServiceHomePart3: React.FC<ServiceHomePart1eProps> = ({
    handleViewChange,
    data,
    onOpenModal,
    onOpenNote,
}) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { customData } = useCustomData();
    const [foundationList, setFoundationList] = useState<eInteriorData[]>([
        { number: '300+', infoString: '企业交流活动' },
        { number: '300+', infoString: '高校交流活动' },
        { number: '100+', infoString: '人才交流活动' },
        { number: '50+', infoString: '技术转移转化' },
        { number: '100+', infoString: '合作企业' },
    ]);

    useEffect(() => {
        const order = [
            'AdvantagesHighlightsOne',
            'AdvantagesHighlightsTwo',
            'AdvantagesHighlightsThree',
            'AdvantagesHighlightsFour',
            'AdvantagesHighlightsFive',
        ];

        const customList: eInteriorData[] = [];

        order.forEach(code => {
            const item = customData.find(d => d.code === code);

            if (item && typeof item.value === 'string') {
                const parts = item.value.split('|');
                // 安全判断，防止格式不对
                const number = parts[0]?.trim() ?? '';
                const infoString = parts[1]?.trim() ?? '';
                customList.push({ number, infoString });
            }
        });

        setFoundationList(customList);
    }, [customData]);

    const goBack = () => {
        handleViewChange('service-index');
    };

    return (
        <div className="service-part3-item">
            {foundationList.map((item, index) => (
                <div className="part3-inner-item" key={index}>
                    <p className="part3-inner-item-first" style={{ color: themeColor }}>
                        {item.number}
                    </p>
                    <p className="part3-inner-item-second">{item.infoString}</p>
                </div>
            ))}
        </div>
    );
};

export default ServiceHomePart3;
